import { combineReducers } from "redux";
import radioValueReducer from "./radioValueReducer";
import sideBarReducer from "./sidebarReducer";
import checkBoxReducer from "./checkBoxReducer";
import appReducer from "./appReducer";
import accountingReducer from "./accountingReducer";
import branchReducer from "./branchReducer";
import businessReducer from "./businessReducer";
import categoryReducer from "./categoryReducer";
import chequeReducer from "./chequeReducer";
import currencyReducer from "./currencyReducer";
import dataTableReducer from "./dataTableReducer";
import factorReducer from "./factorReducer";
import financialReducer from "./financialReducer";
import formReducer from "./formReducer";
import notificationReducer from "./notificationReducer";
import permissionReducer from "./permissionReducer";
import personReducer from "./personReducer";
import productReducer from "./productReducer";
import projectReducer from "./projectReducer";
import printReducer from "./printReducer";
import remittanceReducer from "./remittanceReducer";
import reportReducer from "./reportReducer";
import roleReducer from "./roleReducer";
import shareholderReducer from "./shareholderReducer";
import subscriptionReducer from "./subscriptionReducer";
import ticketReducer from "./ticketReducer";
import transactionReducer from "./transactionReducer";
import transferReducer from "./transferReducer";
import userReducer from "./userReducer";
import warehouseReducer from "./warehouseReducer";
import dashboardReducer from "./dashboardReducer";
import selectBoxTableValueReducer from "./selectBoxTableValueReducer";
import paginationReducer from "./paginationReducer";
import tabActiveKeyReducer from "./tabActiveKeyReducer";
import invoiceReducer from "./invoiceReducer";
import excelReducer from "./excelReducer";
import installmentReducer from "./installmentReducer";
import openingBalanceReducer from "./openingBalanceReducer";
import payrollReducer from "./payrollReducer";
import archiveSidebarReducer from "./archiveReducer";
import manufactureFormulaReducer from "./manufactureFormulaReducer";
import manufacturingOrderReducer from "./manufactureOrderReducer";
import productionReducer from "./productionReducer";
import newsReducer from "./newsReducer";
import costCenterReducer from "./costCenterReducer"

const AllReducer = combineReducers({
  checkBoxReducer,
  radioValueReducer,
  sideBarReducer,
  selectBoxTableValueReducer,
  tabActiveKeyReducer,
  paginationReducer,
  dashboardReducer,
  appReducer,
  accountingReducer,
  branchReducer,
  costCenterReducer,
  businessReducer,
  categoryReducer,
  chequeReducer,
  currencyReducer,
  dataTableReducer,
  factorReducer,
  financialReducer,
  formReducer,
  notificationReducer,
  permissionReducer,
  personReducer,
  productReducer,
  projectReducer,
  remittanceReducer,
  reportReducer,
  roleReducer,
  shareholderReducer,
  subscriptionReducer,
  ticketReducer,
  transactionReducer,
  transferReducer,
  userReducer,
  warehouseReducer,
  invoiceReducer,
  excelReducer,
  installmentReducer,
  printReducer,
  openingBalanceReducer,
  payrollReducer,
  archiveSidebarReducer,
  manufactureFormulaReducer,
  manufacturingOrderReducer,
  productionReducer,
  newsReducer
});

export default AllReducer;
